import { render, staticRenderFns } from "./Ckeditor.vue?vue&type=template&id=3aebe675&scoped=true&"
import script from "./Ckeditor.vue?vue&type=script&lang=js&"
export * from "./Ckeditor.vue?vue&type=script&lang=js&"
import style0 from "./Ckeditor.vue?vue&type=style&index=0&id=3aebe675&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aebe675",
  null
  
)

export default component.exports